import React from 'react'

import Multiline from '../layouts/Multiline.jsx'

import useRequest from '../hooks/useRequest.js'
import { getEventTrends } from '_services/insights-v2.js'
import { formatAudienceTrend } from '../../charts/helpers/formatters.js'

const AudienceTrend = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const {
    time_frame,
    time_range,
    y_labels, // None (DEPRECATED: None as label) | Percent | Count
    title,
    description,
    selected_events,
  } = props.data

  const { data, loading } = useRequest(getEventTrends, { audienceId, timeRange: time_range }, true)

  const formatted = formatAudienceTrend({
    raw: data,
    timeFrame: time_frame,
    selectedEvents: selected_events,
    type: y_labels,
  })

  return (
    <Multiline
      title={title}
      description={description}
      page={props.index + 1}
      timeFrame={time_frame}
      data={formatted}
      yLabel={y_labels}
      isLoading={loading}
    />
  )
}

export default AudienceTrend
